var App = App || {};

App.WidgetBlogPosts = (function ($) {
    'use strict';


    function applyAccessibilityAttributes(splideInstance, carousel) {

        // Splide root element (after mount)
        const root = splideInstance.root;

        if (!root) return;

        if (!root.hasAttribute('aria-label') &&
            !root.hasAttribute('aria-labelledby')) {

            root.setAttribute(
                'aria-label',
                'Blog posts carousel'
            );
        }
        // Splide track usually contains live region attributes
        const track = root.querySelector('.splide__track');

        if (track) {
            track.setAttribute('aria-live', 'polite');
            track.setAttribute('aria-atomic', 'false');
        }
    }


    function Init(selector) {

        if (selector.length) {

            const carousel = selector.find(".splide");
            const slides = carousel.find(".splide__slide");

            if (slides.length > 3) {

                const options = {
                    type: 'slide',
                    speed: 500,
                    arrows: true,
                    pagination: false,
                    perMove: 1,
                    perPage: 3,
                    padding: '1rem',
                    gap: '2.5rem',
                    mediaQuery: 'max',
                    breakpoints: {
                        991: {
                            perPage: 1,
                            padding: '8rem',
                            gap: '1.5rem',
                        },
                        575: {
                            padding: '5rem',
                        }
                    }
                };

                const splide = new Splide(carousel[0], options);

                splide.on('mounted', function () {
                    applyAccessibilityAttributes(splide, carousel);
                });

                splide.mount({});
            }
        }
    }

    return {
        Init: Init
    };

})(jQuery);